var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 63,
    viewBox: "0 0 63 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 31.5C0 14.1012 14.1012 0 31.5 0C48.8988 0 63 14.1012 63 31.5C63 48.8988 48.8988 63 31.5 63C14.1012 63 0 48.8988 0 31.5ZM21.5332 25.6061L27.3287 31.3893L21.5332 37.2832C20.3889 38.4398 20.3889 40.3102 21.5332 41.3561C22.6898 42.6111 24.5602 42.6111 25.6061 41.3561L31.3893 35.6713L37.2832 41.3561C38.4398 42.6111 40.3102 42.6111 41.3561 41.3561C42.6111 40.3102 42.6111 38.4398 41.3561 37.2832L35.6713 31.3893L41.3561 25.6061C42.6111 24.5602 42.6111 22.6898 41.3561 21.5332C40.3102 20.3889 38.4398 20.3889 37.2832 21.5332L31.3893 27.3287L25.6061 21.5332C24.5602 20.3889 22.6898 20.3889 21.5332 21.5332C20.3889 22.6898 20.3889 24.5602 21.5332 25.6061Z",
    fill: "#FFA9AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedX);
export default __webpack_public_path__ + "static/media/red-x.903708e9aff118961abac3894502c31c.svg";
export { ForwardRef as ReactComponent };